import src from "IMAGE";
export default { src, width: 2549, height: 230, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/webp;base64,UklGRnQAAABXRUJQVlA4TGcAAAAvBwAAEM1VICICHggQAAAAAAAIAIAQAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAAAAAUCgAAgAgPBBIAAAAA4PwxAAAGDAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAAAAjAXpQnR2lH4AAA=="};
